import React from 'react';

const PlanetFocusText = ({ text, visibility, position, isHovered }) => {
  // Define a scale multiplier based on hover state
  const hoverScale = isHovered ? 1.1 : 1.0;

  const dynamicStyle = {
    '--text-opacity': visibility,
    top: `${position.y}px`,
    left: `${position.x}px`,
    // Apply the hoverScale to the final transform calculation
    transform: `translate(-50%, -50%) scale(calc((0.95 + ${visibility} * 0.05) * ${hoverScale}))`,
  };

  return (
    <div 
      className="planet-text-container"
      style={dynamicStyle}
    >
      <h1>{text}</h1>
    </div>
  );
};

export default PlanetFocusText;
